/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import EditableBtn from 'components/lib/EditableBtn';
import { useContext, useRef } from 'react';
import { unlockInteraction } from 'services/unlockInteraction';
import { FiveStarRatingContext } from './FiveStarRating_v2';
import { interactionContext } from './interactionContext';
import { addScormResponseAction } from 'actions/addScormResponseAction';
import { useDispatch } from 'react-redux';
import { getLocalStorageUserId } from 'hosting/context';
import {
  submitToCollectClassic,
  submitToCollectNew,
} from 'services/submitToCollect';
import { HostingContext, Session } from 'hosting/context';
import { useEffect } from 'react';

const SubmitBtn = props => {
  const context = useContext(interactionContext)!;
  const hostedContext = useContext(HostingContext)! as Session & {
    currentSession?: {
      userId: string | number;
    };
  };

  const {
    hasLearnerIdentity,
    // emailRequired,
    learnerIdentity,
    rating,
    message,
    alertLearnerIdentity,
    onSubmit,
  } = useContext(FiveStarRatingContext)!;

  const dispatch = useDispatch();

  const {
    emailRequired = 1,
    collectionKey = '',
    ratingEndpoint,
    submissionEmailDestination,
    subject,
    includeMessageText = true,
    isTextEntry,
  } = context.props;

  let reference = context.props?.reference || context.id;

  const submitted = unlockInteraction(context.id, 1);

  let enabled = includeMessageText === false || message !== '';

  if (['collect', 'collectNew'].includes(ratingEndpoint) && emailRequired) {
    if (includeMessageText) {
      enabled = hasLearnerIdentity && message !== '';
    } else {
      enabled = hasLearnerIdentity;
    }
  }

  const userId =
    hostedContext?.currentSession?.userId || getLocalStorageUserId();

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        width: 100%;
        margin: 20px 0 0 0;
        ${!window.dev() &&
          `
            opacity: ${enabled ? 1 : 0.25};
            pointer-events: ${enabled ? 'auto' : 'none'};
            transition: opacity 0.5s;
        `}
      `}
    >
      <EditableBtn
        onClick={() => {
          //
          if (ratingEndpoint === 'scorm') {
            const questionElement = document.querySelector(
              `#i${context.id} .rating-text`
            ) as HTMLElement;

            let question = '';

            if (questionElement) {
              question = questionElement.innerText;
            }

            const type = message ? 'fill-in' : 'likert';
            const reportable = message ? 'fillin' : 'likert';

            let response;
            const normalizedRating =
              rating !== null ? Number(rating) + 1 : null;

            if (type === 'likert') {
              response = normalizedRating;
            } else {
              response = normalizedRating
                ? `Rating: ${normalizedRating}, Message: ${message}`
                : message || '';
            }

            const action = {
              id: context.id,
              type,
              question,
              reportable,
              response,
              correct: response,
              result: 1,
            };

            dispatch(addScormResponseAction(action as any));

            onSubmit(true);
            submitted(1);
            //
            return;
          }
          //
          //

          if (ratingEndpoint === 'collect') {
            //
            if (!collectionKey) {
              alert(
                'No collection key has been provided by the author of this module.'
              );

              onSubmit();
              submitted(1);
              return;
            }
            //

            const ratingCalculated =
              rating === null || isTextEntry ? undefined : rating + 1;

            submitToCollectClassic({
              key: collectionKey,
              ...(rating && { rating: ratingCalculated }),
              message,
              identity: learnerIdentity,
              reference,
              onComplete(result) {
                // console.log(`SUBMISSION TO COLLECT CLASSIC = '${result} !!!`);
                //
                onSubmit();
              },
            });

            submitted(1);
            return;
          }

          if (ratingEndpoint === 'collectNew') {
            const source = (window as any).getParams().source;

            if (
              window?.location?.href?.includes('http://localhost:3011') ||
              source === 'preview'
            ) {
              //
              // console.log(
              //   source,
              //   'BAIL !!! do not send data to collect new !!!'
              // );

              onSubmit();
              submitted(1);
              return;
            }

            const projectId = (window as any).getParams().projectId;
            const accountId = (window as any).getParams().accountId;
            const versionId = (window as any).getParams().versionId;

            const ratingCalculated =
              rating === null || isTextEntry ? undefined : rating + 1;

            const collectPayload = {
              accountId,
              userId,
              projectId,
              versionId,
              interactionId: context?.id,
              ...(message && {
                message,
              }),
              ...(rating && { rating: ratingCalculated }),
              ...(learnerIdentity && {
                userReference: learnerIdentity,
              }),
              source,
            };

            submitToCollectNew({
              ...collectPayload,
              onComplete(result) {
                // console.log(`SUBMISSION TO COLLECT NEW = ${result}`);
                //
                onSubmit();
              },
            });

            submitted(1);
            return;
          }

          if (ratingEndpoint === 'hosting') {
            onSubmit();
            submitted(1);
            //
            return;
          }

          const parsedMessage = `Rating: ${
            rating !== null ? rating + 1 : 'not rated'
          }\r\n\r\n${message}`;

          location.href = `mailto:${submissionEmailDestination}?${subject &&
            `subject=${encodeURIComponent(subject)}&`}body=${encodeURIComponent(
            parsedMessage
          )}`;

          onSubmit();
          submitted(1);
        }}
        enabled={enabled}
        {...props}
      />
    </div>
  );
};

export default SubmitBtn;
